export const categoryVehicle = [
	'2 EIXOS',
	'3 EIXOS',
	'4 EIXOS',
	'5 EIXOS',
	'6 EIXOS',
	'7 EIXOS',
	'8 EIXOS',
	'9 EIXOS',
	'10 EIXOS',
	'11 EIXOS',
];
export const brandVehicle = ['FORD', 'VOLKSWAGEN', 'SCANIA', 'VOLVO', 'MERCEDES', 'MAN', 'IVECO', 'DAF', 'GMC'];
export const categoryLicenseDrive = ['A', 'AB','AD', 'AE','D', 'E'];
export const userRoles = ['ADMINISTRADOR', 'OPERADOR'];
export const orderFieldsTransportLogisticRoute = [
	{ id: 1, name: 'Nº Crecrescente' },
	{ id: 2, name: 'Nº Decrescente' },
	{ id: 3, name: 'Data Decrescente' },
	{ id: 4, name: 'Data Crescente' },
	{ id: 5, name: 'Nº Nota Fiscal Crescente' },
	{ id: 6, name: 'Nº Nota Fiscal Decrescente' },
	{ id: 7, name: 'Data Emissão Nota Fiscal Crescente' },
	{ id: 8, name: 'Data Emissão Nota Fiscal Decrescente' },
	{ id: 9, name: 'Data Cancelamento Crescente' },
	{ id: 10, name: 'Data Cancelamento Decrescente' },
	{ id: 10, name: 'Peso Crescente' },
	{ id: 11, name: 'Peso Decrescente' },
];

export const typesCustomers = ['FÁBRICA', 'PORTO', 'OUTROS'];
